import React from 'react';

import Button from '../../components/UI/Button/Button';
import Info from '../../components/UI/Info/Info';

import classes from './Notice.module.scss';

const Notice = props => {
    let errorMessage = null;

    switch (props.location.state.type) {
        case 'success':
            errorMessage = 'Success';
            break;
        case 'failed':
            errorMessage = 'Error';
            break;
        default:
            errorMessage = null;
    }

    console.log(props.location.state.type, errorMessage);

    const onCloseHandler = () => {
        props.history.push('/');
    }

    return <div className={classes.Right}>
        <h1>{errorMessage}</h1>
        <Info>
            {props.location.state.message}
        </Info>
        <div className={classes.Button}>
            <Button clicked={onCloseHandler}>Close</Button>
        </div>
    </div>
}

export default Notice;